import * as EP from "./endpoints";
import HTTP from "@/packages/http";

export const UserService = {
  getUsers() {
    return HTTP.get(EP.GET_USERS).then(({ data }) => data);
  },
  deleteUser(id) {
    return HTTP.delete(EP.DELETE_USER + id).then(({ data }) => data);
  },
  addUser(formData) {
    return HTTP.post(EP.ADD_USER, { ...formData }).then(({ data }) => data);
  },
  updateUsername(formData) {
    return HTTP.patch(EP.UPDATE_USER_NAME, { ...formData }).then(({ data }) => data);
  }
};
export const ExporterService = {
  getExporters() {
    return HTTP.get(EP.GET_EXPORTERS).then(({ data }) => data);
  },
  deleteExporter(id) {
    return HTTP.delete(EP.DELETE_EXPORTER + id).then(({ data }) => data);
  },
  addExporter(formData) {
    return HTTP.post(EP.ADD_EXPORTER, { ...formData }).then(({ data }) => data);
  },
  updateExporter(formData) {
    return HTTP.patch(EP.UPDATE_EXPORTER + formData.exporterId, { ...formData }).then(({ data }) => data);
  },
  addAdCode(formData) {
    return HTTP.post(EP.ADD_AD_CODE + formData.exporterId, { ...formData }).then(({ data }) => data);
  },
  deleteAdCode(id) {
    return HTTP.delete(EP.DELETE_AD_CODE + id).then(({ data }) => data);
  }
};
export const AccountService = {
  updateAccount(formData) {
    return HTTP.patch(EP.UPDATE_ACCOUNT_SETTINGS, { ...formData }).then(({ data }) => data);
  },
  addTimePeriod(formData) {
    return HTTP.post(EP.ADD_TIME_PERIOD, { ...formData }).then(({ data }) => data);
  },
  getTimePeriods() {
    return HTTP.get(EP.GET_TIME_PERIODS).then(({ data }) => data);
  },
  deleteTimePeriod(id) {
    return HTTP.delete(EP.DELETE_TIME_PERIOD + id).then(({ data }) => data);
  },
  updateTimePeriod(formData) {
    return HTTP.patch(EP.UPDATE_TIME_PERIOD, { ...formData }).then(({ data }) => data);
  },
  notifyRequest() {
    return HTTP.post(EP.ADD_NOTIFICATION_REQUEST).then(({ data }) => data);
  },
  getAccountDetails() {
    return HTTP.get(EP.GET_ACCOUNT_DETAILS).then(({ data }) => data);
  }
};
